import { render, staticRenderFns } from "./FixSign.vue?vue&type=template&id=48bdbbf7"
import script from "./FixSign.vue?vue&type=script&lang=js"
export * from "./FixSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports